/** @jsx jsx */
import { jsx } from '@compiled/react';
import { Inline, Box, Flex } from '@atlaskit/primitives/compiled';
import CommentRestrictedToIndicator from './CommentRestrictedToIndicator.tsx';
import CommentUnreadIndicator from './CommentUnreadIndicator.tsx';
import CommentCopyLink from './CommentCopyLink.tsx';
import SlackSyncStatus from './SlackSyncStatus.tsx';
import CommentPinIndicator from './CommentPinIndicator.tsx';

const CommentStatus = () => {
	return (
		<Flex justifyContent="space-between">
			<Inline space="space.075" alignBlock="center">
				<SlackSyncStatus />
				<CommentPinIndicator />
				<CommentRestrictedToIndicator />
				<Box paddingInline="space.050">
					<CommentCopyLink />
				</Box>
			</Inline>
			<CommentUnreadIndicator />
		</Flex>
	);
};

export default CommentStatus;
